import { mutator } from 'satcheljs';
import getStore from '../store/appHostSearchStore';
import onOpenMetaOsApp from 'owa-app-host-state/lib/actions/onOpenMetaOsApp';

mutator(onOpenMetaOsApp, () => {
    getStore().eventRegistrationsMap.clear();
});
